module.exports = __webpack_public_path__ + "img/reminder_menu_2dolist.79cd017a.png";